module.exports = __webpack_public_path__ + "assets/webgl/neons.jpg.b89e19e4.webp";